import { useState, useRef, useEffect } from 'react';
import axios from 'axios';

interface TicketingDataProps {
  isExpanded: boolean
}

interface UploadedFile {
  id: string;
  name: string;
  size: number;
  uploadDate: Date;
  status: "success" | "error";
  rowCount?: number;
  errorMessage?: string;
}

type CsvRow = {
  salesrep?: string;
  cin7rep?: string;
  repemail?: string;
  repphone?: string;
};

interface RepRow {
  id: string;
  fileId?: string;
  salesRep: string | null;
  cin7Rep: string | null;
  repEmail: string | null;
  repPhone: string | null;
}

    export const TicketingData: React.FC<TicketingDataProps> = ({
     isExpanded

    }) => {
        const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
        const [isDragging, setIsDragging] = useState(false);
        const fileInputRef = useRef<HTMLInputElement>(null);
const [repRows, setRepRows] = useState<RepRow[]>([]);
    const [loading, setLoading] = useState<boolean>();
    const [brandsInput, setBrandsInput] = useState<string>('');
    const [brandsSubmitting, setBrandsSubmitting] = useState<boolean>(false);
    const [brandsMessage, setBrandsMessage] = useState<string>('');

useEffect(() => {
  const brands = window.UsersData?.brands_approval;

  setBrandsInput(
    Array.isArray(brands)
      ? brands.join(', ')
      : brands || ''
  );
}, []);
        const dragCounter = useRef(0);

        useEffect(() => {
        console.log(uploadedFiles, 'uploaded files')
        },[uploadedFiles])

  const handleDragEnter = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  if (!e.currentTarget.contains(e.relatedTarget as Node)) {
    setIsDragging(false);
  }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    processFiles(files);
  };

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      processFiles(files);
    }
  };

  const processFiles = (files: File[]) => {
    files.forEach((file) => {
      // Validate file type
      if (!file.name.toLowerCase().endsWith('.csv')) {
        const errorFile = createErrorFile(file.name, file.size, 'error', 'Only CSV files are allowed')
        setUploadedFiles(prev => [errorFile, ...prev]);
        return;
      }
       if (file.size > 5000000) {
        const errorFile = createErrorFile(file.name, file.size, 'error', 'File size exceeds 5 MB')
        setUploadedFiles(prev => [errorFile, ...prev]);
        return;
      }

      // Read the file to count rows (simulate processing)
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target?.result as string;
        const lines = text.split('\n').filter(line => line.trim() !== '');
        const rowCount = Math.max(0, lines.length - 1); // Subtract header row

           if (!lines || lines.length < 2) {
         const errorFile = createErrorFile(file.name, file.size, 'error', 'No data ')
        setUploadedFiles(prev => [errorFile, ...prev]);
            return
           }

        const headers = lines[0]
  .split(/,|\t/)
  .map(h => h.replace(/\r/g, "").trim());
        const rows = lines.slice(1);

           const acceptedHeaders = [
  "salesrep",
  "cin7rep",
  "repemail",
  "repphone"
]
console.log(headers, 'headers')

const normalizedAcceptedHeaders = acceptedHeaders.map(h =>
  h.toLowerCase().trim()
);

const invalidHeaders = headers.filter(
  (header) => !normalizedAcceptedHeaders.includes(header.toLowerCase().trim())
);
if (invalidHeaders.length > 0) {
  const errorFile = createErrorFile(
    file.name,
    file.size,
    'error',
    `Invalid headers: ${invalidHeaders.join(', ')}`
  );

  setUploadedFiles(prev => [errorFile, ...prev]);
  return;
}

      reader.onerror = () => {
        const errorFile: UploadedFile = {
          id: Math.random().toString(36).substr(2, 9),
          name: file.name,
          size: file.size,
          uploadDate: new Date(),
          status: "error",
          errorMessage: "Error reading file"
        };
        setUploadedFiles(prev => [errorFile, ...prev]);
      };

       const allRowsValid = rows.every((row, index) => {
         const values = row.split(/,|\t/).map(v => v.trim());
         const rowObject = headers.reduce<Record<string, string>>((acc, header, i) => {
    acc[header.toLowerCase()] = values[i];
    return acc;
  }, {});

  const errors = dataValidationCheck(rowObject);
  if (errors.length > 0) {
    const errorFile = createErrorFile(
      file.name,
      file.size,
      "error",
      `Row ${index + 1} error(s): ${errors[0]}`
    );
    setUploadedFiles(prev => [errorFile, ...prev]);
    return false;
  }

  return true;
});
console.log(allRowsValid)
if (allRowsValid == false) {
  return;
}

const uploadedFile: UploadedFile = {
          id: Math.random().toString(36).substr(2, 9),
          name: file.name,
          size: file.size,
          uploadDate: new Date(),
          status: "success",
          rowCount: rowCount
        };

const parsedRows: RepRow[] = rows.map((row) => {
  const values = row.split(/,|\t/).map(v => v.trim());
  const rowObject = headers.reduce<Record<string, string>>((acc, header, i) => {
    acc[header.toLowerCase()] = values[i];
    return acc;
  }, {});

  const repRow: RepRow = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    fileId: uploadedFile.id,
    salesRep: rowObject.salesrep || null,
    cin7Rep: rowObject.cin7rep || null,
    repEmail: rowObject.repemail || null,
    repPhone: rowObject.repphone || null,
  };
  return repRow;
});

setRepRows(prev => [...parsedRows, ...prev]);
const upload = await uploadRepData(parsedRows);

if (upload === true) {
  setUploadedFiles(prev => [uploadedFile, ...prev]);
}
else {
            const errorFile: UploadedFile = {
          id: Math.random().toString(36).substr(2, 9),
          name: file.name,
          size: file.size,
          uploadDate: new Date(),
          status: "error",
          errorMessage: "Error uploading file"
        };
            setUploadedFiles(prev => [errorFile, ...prev]);

}
}

      reader.readAsText(file);
    });
  };
useEffect(() =>{   console.log("CSV as JSON:", repRows);},[repRows])

  const createErrorFile = ( name: string,size: number, status: "error" | 'success', errorMessage: string) => {
const error = {
    id: Math.random().toString(36).substr(2, 9),
    name: name,
    size: size,
    uploadDate: new Date(),
    status: status,
    errorMessage:  errorMessage
}
 return error;

  }

      const uploadRepData = async (repData: RepRow[]) => {
    try {
        setLoading(true)
const res = await axios.post(
      window.tagabelData.root_url + '/wp-json/custom/v1/upload-reps',
      { repData: repData },
      {  headers: {
         'X-WP-Nonce': window.tagabelData?.nonce,
       },
} );
console.log('Upload response:', res.data);
    return true

    } catch (error) {
      console.error('Failed to upload rep data:', error);

    } finally {
        setLoading(false)
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  const handleSubmitBrands = async () => {
    const brands = brandsInput
      .split(',')
      .map(b => b.trim())
      .filter(b => b.length > 0);

    if (brands.length === 0) {
      setBrandsMessage('Please enter at least one brand');
      return;
    }

    try {
      setBrandsSubmitting(true);
      setBrandsMessage('');
      await axios.post(
        window.tagabelData.root_url + '/wp-json/custom/v1/brands_approval',
        { brands },
        { headers: { 'X-WP-Nonce': window.tagabelData?.nonce } }
      );
      setBrandsMessage('Brands updated successfully');
    } catch (error) {
      console.error('Failed to update brands:', error);
      setBrandsMessage('Failed to update brands');
    } finally {
      setBrandsSubmitting(false);
    }
  };

  const handleDeleteFile = (id: string) => {
    setUploadedFiles(prev => prev.filter(file => file.id !== id));
    setRepRows(prev => prev.filter(row => row.fileId !== id))
  };

  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

const dataValidationCheck = (row: CsvRow) => {
  const errors: string[] = [];

  if (!row.salesrep) {
    errors.push('salesRep is required');
  }

  if (!row.cin7rep) {
    errors.push('cin7Rep is required');
  }

  if (row.repemail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.repemail)) {
    errors.push('repEmail must be a valid email');
  }

  return errors;
};

  const successfulUploads = uploadedFiles.filter(f => f.status === "success").length;
  const failedUploads = uploadedFiles.filter(f => f.status === "error").length;
  // jsx
  return (
    <>
      <div   className={`transition-[padding-left] duration-300 ease-in-out ${
    isExpanded ? "navbar-spacer-open" : "navbar-spacer-closed"}`}>

      <div className="p-6 space-y-6">
        {/* Header */}
        <div className="flex flex-col space-y-3">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl">Sales Rep Upload</h1>
              <p className="text-muted-foreground mt-1">
                Upload CSV Sales rep info
              </p>
            </div>
          </div>
        </div>

        {/* Upload Area */}
        <div className="bg-card text-card-foreground flex flex-col gap-6 rounded-xl border border-gray-200 p-8">
          <div
            className={`border-2 border-dashed border-gray-200 rounded-xl p-12 transition-all duration-300 ${
              isDragging
                ? "border-[#0090DA] bg-[#0090DA]/5 scale-105"
                : "border-border hover:border-[#0090DA]/50 hover:bg-[#0090DA]/5"
            }`}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <div className="text-center">
              <div className={`inline-flex items-center justify-center w-20 h-20 rounded-full mb-6 transition-all duration-300 ${
                isDragging
                  ? "bg-gradient-to-br from-[#0090DA] to-[#00426A] scale-110"
                  : "bg-gradient-to-br from-[#0090DA]/10 to-[#00426A]/10"
              }`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 className={`w-10 h-10 transition-colors duration-300 ${
                  isDragging ? "text-white" : "text-[#0090DA]"
                }`}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" x2="12" y1="3" y2="15"></line></svg>

              </div>

              <h2 className="text-xl text-[#00426A] mb-2">
                {isDragging ? "Drop your CSV files here" : "Drag & Drop CSV Files"}
              </h2>

              <p className="text-muted-foreground mb-6 max-w-md mx-auto">
                Upload your sales rep data in CSV format.
              </p>

              <button
                onClick={handleBrowseClick}
                className="px-6 py-3 bg-gradient-to-br from-[#0090DA] to-[#00426A] text-white rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-200"
              >
                Browse Files
              </button>

              <input
                ref={fileInputRef}
                type="file"
                accept=".csv"
                multiple
                onChange={handleFileInput}
                className="hidden"
              />

              <p className="text-xs text-muted-foreground mt-4">
                Supported format: CSV (.csv)
              </p>
            </div>
          </div>
        </div>

        {/* Uploaded Files List */}
        {uploadedFiles.length > 0 && (
          <div className="p-6 bg-white">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 rounded-lg bg-gradient-to-br from-[#0090DA]/10 to-[#00426A]/10">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-file-spreadsheet w-5 h-5 text-[#0090DA]"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M8 13h2"></path><path d="M14 13h2"></path><path d="M8 17h2"></path><path d="M14 17h2"></path></svg>
              </div>
              <h2 className="text-xl">Uploaded Files</h2>
              <span className="bg-[#0090DA]/10 text-[#0090DA] border-[#0090DA]/20">
                {uploadedFiles.length}
              </span>
            </div>

            <div className="border-2 border-border rounded-lg overflow-hidden border-gray-200 uploads-container">
              {/* Table Header */}
              <div className="bg-gradient-to-r from-[#00426A]/10 to-[#0090DA]/10 px-6 py-4 grid grid-cols-[40px_3fr_1.5fr_1.5fr_1.5fr_1fr_80px] gap-4 ticketing-item-phone ticketing-item-phone-one">
                <div></div>
                <div>
                  <span className="text-sm ticketing-div-align text-[#00426A]">File Name</span>
                </div>
                <div>
                  <span className="text-sm ticketing-div-align text-[#00426A]">Size</span>
                </div>
                <div>
                  <span className="text-sm ticketing-div-align text-[#00426A]">Upload Date</span>
                </div>
                <div>
                  <span className="text-sm ticketing-div-align text-[#00426A]">Rows</span>
                </div>
                <div>
                  <span className="text-sm ticketing-div-align text-[#00426A]">Status</span>
                </div>
                <div></div>
              </div>

              {/* Table Body */}
              <div className="divide-y divide-border">
                {uploadedFiles.map((file) => (
                  <div
                    key={file.id}
                    className="px-6 py-4 grid grid-cols-[40px_3fr_1.5fr_1.5fr_1.5fr_1fr_80px] gap-4 items-center hover:bg-gradient-to-r hover:from-[#0090DA]/5 hover:to-transparent transition-all duration-200 border-gray-200 ticketing-item-phone ticketing-item-phone-two"
                  >
                    <div>

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className={`w-5 h-5 ${
                        file.status === "success" ? "text-[#43B02A]" : "text-red-500"
                      }`} ><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M8 13h2"></path><path d="M14 13h2"></path><path d="M8 17h2"></path><path d="M14 17h2"></path></svg>

                    </div>

                    <div>
                      <div className="font-medium text-[#00426A]">{file.name}</div>
                      {/* custom error message */}
                      {file.status === "error" && file.errorMessage && (
                        <div className="text-xs text-red-600 mt-1">{file.errorMessage}</div>
                      )}
                    </div>

                    <div className="text-sm text-muted-foreground padding-ticketing-items">
                      {formatFileSize(file.size)}
                    </div>

                    <div className="text-sm text-muted-foreground padding-ticketing-items">
                      {file.uploadDate.toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </div>

                    <div className="text-sm text-muted-foreground padding-ticketing-items">
                      {file.rowCount !== undefined ? file.rowCount.toLocaleString() : '-'}
                    </div>

                 <div>
                      {file.status === "success" ? (
                        <span className="inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-primary/90 bg-[#43B02A]/10 text-[#43B02A] border-[#43B02A]/20">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-circle-check-big w-3 h-3 mr-1"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
                          Success
                        </span>
                      ) : (
                        <span className="inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-primary/90 bg-red-500/10 text-red-600 border-red-500/20">
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-circle-x w-3 h-3 mr-1"><circle cx="12" cy="12" r="10"></circle><path d="m15 9-6 6"></path><path d="m9 9 6 6"></path></svg>                          Error
                        </span>
                      )}
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleDeleteFile(file.id)}
                        className="p-2 hover:bg-red-50 rounded transition-colors"
                        title="Delete"
                      >
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-trash2 lucide-trash-2 w-4 h-4 text-red-600"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line></svg>                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}


      </div>

    </div>
    <div className='flex justify-center flex-col items-center bg-[#e2e2e2] w-fit m-auto p-5'>
  <h2 className='text-2xl font-bold pb-3'>Brands Requiring Approval</h2>
  <p className=' pb-5'>Please provide comma seperated values ex Johnnie-O, Nexus Outdoors, ect...</p>
  <input
    className='users-input'
    type="text"
    value={brandsInput}
    onChange={(e) => setBrandsInput(e.target.value)}
    disabled={brandsSubmitting}
  />
  <div className="mt-5">

  <button className='save-button' onClick={handleSubmitBrands} disabled={brandsSubmitting}>
    {brandsSubmitting ? 'Saving...' : 'Submit'}
  </button>
  {brandsMessage && <p className='pt-3 text-sm'>{brandsMessage}</p>}
  </div>
</div>
</>
  )
}
